import app from '../app';
import Page, { IPageAttrs } from '../../common/components/Page';
import NotificationList from '../components/NotificationList';
import type Mithril from 'mithril';
import extractText from '../../common/utils/extractText';
import NotificationListState from '../../forum/states/NotificationListState';
import Button from '../../common/components/Button';
import LinkButton from '../../common/components/LinkButton';
import avatar from '../../common/helpers/avatar';
import nickname from '../../common/helpers/nickname';
import signName from '../../forum/dianLiang/signName';
import UserCard from '../../forum/components/UserCard';
import RefundModal from '../dianLiang/RefundModal';
import PayConfirmModal from '../dianLiang/PayConfirmModal';
import AlertUtil from '../dianLiang/alertUtil';
import User from '../../common/models/User';
import AgreementModal from '../components/AgreementModal';

/**
 * The `LikesPage` component shows the notifications list. It is only
 * used on mobile devices where the notifications dropdown is within the drawer.
 */
export default class PayPage<CustomAttrs extends IPageAttrs = IPageAttrs> extends Page<CustomAttrs> {
  // 平台币剩余
  protected balance = 0;
  // 商品列表
  protected commodityList = [];
  // 退款金额
  protected refund = 0;
  // 支付类型
  protected payType = [];
  // 折扣
  protected pcChargeDiscount = 100;


  oninit(vnode: Mithril.Vnode<CustomAttrs, this>) {
    super.oninit(vnode);
    app.history.push('notifications', extractText(app.translator.trans('dl-person.forum.pay')));

    app.notifications = new NotificationListState({
      filter: { type: ['postPayed'] },
      // sort: 'newest',
    });

    app.notifications.load();
    // app.notifications.refreshParams(param);
    this.bodyClass = 'App--notifications';
    ['.App', '.App-content'].forEach((selector) => {
      document.querySelectorAll(selector).forEach((element) => {
        element.style.paddingBottom = '0';
      });
    });
    this.sdkUserPc();
  }
  onremove(vnode: Mithril.VnodeDOM<CustomAttrs, this>): void {
    super.onremove(vnode);
    app.modal.close();
  }
  sdkUserPc() {
    // 查询平台币余额
    app
      .request({
        method: 'GET',
        url: app.forum.attribute('apiUrl') + '/sdkUserPc',
      })
      .then((res) => {
        if (res.balance != null && res.balance != undefined) {
          this.balance = res.balance;
        }
        app.store.balance = this.balance;
        this.commodityList = res.commodityList;
        this.pcChargeDiscount = res.pcChargeDiscount;
        this.refund = res.refund;
        this.payType = res.payType;
        m.redraw();
      });
  }

  view() {
    let baseUrl = app.forum.attribute('baseUrl');
    let userLink = app.data.pkgLogo.userLink;
    let localeUserLink = '';
    if (userLink) {
      // 将字符串映射转换为 JavaScript 对象
      const obj = JSON.parse(userLink);
      // 创建 Map 对象并初始化
      const map = new Map(Object.entries(obj));
      // 获取特定键的值
      localeUserLink = map.get(app.data.locale);
    }
    return (
      <div className="Wallet">
        <div className="wallet-user-box">{this.UserInfoBox()}</div>
        <div className="wallet-title">{app.translator.trans('dl-pay.forum.user.my_wallet')}</div>
        <div className="wallet-balance">
          <div className="name">{app.translator.trans('dl-pay.forum.user.current_wallet_balance')}</div>
          <div className="balance">
            <span>
              {this.refund == 0 || this.refund == undefined
                ? ''
                : app.translator.trans('dl-pay.forum.operation.refund_review_in_progress', { refund: this.refund })}
            </span>
            ${this.balance.toFixed(2)}
          </div>
        </div>
        <div className="Wallet-recharge-box">
          <div className="recharge-box">
            {this.commodityList &&
              this.commodityList.map((item, index) => (
                <div className="recharge-item">
                  <div className="recharge-bg">
                    <div className="recharge-item-left">
                      <div className="recharge-item-name">
                        {app.translator.trans('dl-pay.forum.order.recharge_label')}
                        <span>{item.goodsId}</span>
                      </div>
                      {/* <div className="recharge-item-name">充值$123.00</div> */}

                      {/* <div className='recharge-item-discount'>-10%</div> */}
                    </div>
                    <div className="recharge-item-right">
                      <div className="recharge-item-price">
                        {/* <div className='original-price'>$54.00</div> */}
                        <div className="current-price">${item.money.toFixed(2)}</div>
                        {/* <div className="current-price">$123.00</div> */}
                      </div>
                      <div
                        className="recharge-item-btn"
                        onclick={() => {
                          app.modal.show(PayConfirmModal, { price: item.money, payType: this.payType, goodsId: item.goodsId });
                        }}
                      >
                        {app.translator.trans('dl-pay.forum.order.recharge')}
                      </div>
                    </div>
                  </div>
                </div>
              ))}
          </div>
        </div>

        <div className="wallet-remind">
          <p>{app.translator.trans('dl-pay.forum.comfirm.money_use')}</p>
          <p>
            {app.translator.trans('dl-pay.forum.comfirm.more_use')}
            <a href={localeUserLink ? (localeUserLink.includes('http') ? localeUserLink : baseUrl + localeUserLink) : '#'}>
              {/* <u onclick={() => app.modal.show(AgreementModal, { data: userAgreement, title: app.translator.trans('dl-pay.forum.comfirm.user_agreement_text') }, true)}> */}
              {app.translator.trans('dl-pay.forum.comfirm.user_agreement')}
              {/* </u> */}
            </a>
          </p>
          <p>
            <u
              className="wallet-refund"
              onclick={() => {
                if (this.balance == 0) {
                  AlertUtil.onWarn(app, app.translator.trans('dl-response.forum.warn.balance_is_null'));
                  return;
                }
                app.modal.show(RefundModal, {
                  balance: this.balance,
                  sdkUserPc: () => {
                    this.sdkUserPc();
                  },
                });
              }}
            >
              {/* {app.translator.trans('dl-pay.forum.user.my_want_refund')} */}
            </u>
          </p>
        </div>
      </div>
    );
  }
  UserInfoBox() {
    // let user = app.store.getById<User>('users', String(app.session.user?.id()))
    let user = app.session.user;

    let userLevel = user?.userLevel();

    return (
      <div className="Wallet-userinfo">
        <div className="user-avatar-box">
          <div className="user-avatar">{avatar(user)}</div>
        </div>
        <div className="user-info">
          <div className="info-item">
            <span className="UserCard-identity-person-nickNameTitle">{app.translator.trans('dl-person.forum.nickName')}</span>
            <span className="UserCard-identity-person-nickName">{nickname(user)}</span>
          </div>
          <div className="info-item">
            <span className="UserCard-identity-person-nickNameTitle">{app.translator.trans('dl-person.forum.signName')}</span>&nbsp;
            <div
              className="UserCard-identity-person-nickName person-container"
              id="scrollText"
              onclick={() => {
                UserCard.prototype.onScrollToEnd();
              }}
            >
              <div className="scroll-text">{signName(user)}</div>
            </div>
          </div>
          <div className="info-item">
            <Button className="UserCard-identity-person" onclick={() => AlertUtil.copyToClipboar(user.uniqueID())}>
              <span className="UserCard-identity-person-nickNameTitle">{app.translator.trans('dl-person.forum.ID')}</span>&nbsp;
              <span className="UserCard-identity-person-nickName">{user.uniqueID()}</span>
              <img src={`${app.data.pkgLogo.cdnUrl}/${app.data.pkgLogo.ossFile}/img-fz.png`}></img>
            </Button>
          </div>
        </div>
        <LinkButton
          className="person-pointNumber-container"
          // href={history?.backUrl()}
        >
          <span className="person-pointNumer-icon">
            <i class="fas fa-star"></i>
          </span>
          <span className="person-pointNumer">
            {userLevel?.allIntegra() > 999
              ? app.translator.trans('dl-person.forum.integra_more')
              : app.translator.trans('dl-person.forum.integra', { integra: userLevel.allIntegra() })}
          </span>
        </LinkButton>
        <LinkButton className="UserCard-identity-person-setting" href={app.route('settings2')}>
          <img src={`${app.data.pkgLogo.cdnUrl}/${app.data.pkgLogo.ossFile}/img-szbai.png`} />
        </LinkButton>
      </div>
    );
  }
}
